import { useTranslation } from 'react-i18next'

import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'

import { GuestInformationGrid } from './GuestInformationGrid.tsx'
import { GuestInformationGridElement } from './GuestInformationGridElement.tsx'

interface GuestInformationPaymentInformationProps {
	source: string
	status: string
}

/**
 * Show source and status of payment
 *
 * @author Ivan Shchedrovskyi
 */
export const GuestInformationPaymentInformation = wwtMemo(
	({ source, status }: GuestInformationPaymentInformationProps) => {
		wwtPerformanceLog('GuestInformationPaymentInformation')

		const { t } = useTranslation('room-page', {
			keyPrefix: 'reservationTab.paymentInformation'
		})

		return (
			<article>
				<h2 className="ts-headline-4 mb-4">{t('title')}</h2>

				<GuestInformationGrid>
					<GuestInformationGridElement
						title={t('sourceTitle')}
						content={source}
					/>
					<GuestInformationGridElement
						title={t('statusTitle')}
						content={status}
					/>
				</GuestInformationGrid>
			</article>
		)
	}
)
